/**
 * en-GB messages added by Phase 2 task C3 (docs/PHASE-2-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const c3EnGB = {
    'error.email_attachment_invalid': 'That attachment cannot be used. Check the file still exists and try again.',
    'error.email_attachment_too_large': 'The attachments are too large. Each file can be up to 5 MB and the total up to 10 MB.',
    'settings.core.scheduling.tickSeconds': 'How often scheduled checks run (seconds, minimum 30)',
    'settings.core.scheduling.maxLateMinutes': 'Skip a scheduled task missed by more than this many minutes',
    'settings.core.links.ratePerTokenPerMinute': 'Requests per minute allowed for one public link (0 = no limit)',
    'settings.core.api.ratePerMinute': 'Public API requests per minute for each key (0 = no limit)',
};
//# sourceMappingURL=c3.js.map